// src/hooks/useLocale.ts
import { Locale } from '@varlet/ui'

/**
 * 格式化
 * @param str 
 * @param params 
 * @returns 
 */
function _format(str: string, params?: Record<string, string | number>) {
  if (!params) return str
  return str.replace(/\{(\w+)\}/g, (_, key) => params[key]?.toString() ?? '')
}

/**
 * 语言HOOK
 * @returns 
 */
export function useLocale() {
  const t = (path: string, params?: Record<string, string | number>): string => {
    if (!path)
      return '';
    const segments = path.split('.')
    let value = Locale.currentMessage;

    for (const key of segments) {
      value = value.value?.[key] || (value as any)?.[key]
      if (value === undefined) return path // fallback
    }

    return _format(typeof value === 'string' ? value : path, params);
  }

  return { t }
}
